import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punedarshantempo() {



const cardData = {


keyword: "Pune Darshan Tempo Traveller On Rent",

headingDescription:
    "Ruturaj Enterprises provides comfortable and convenient Pune Darshan Tempo Traveller services for families, friends, corporate groups, tourists, and organized travel parties. With AC, luxury, 13-seater, 17-seater, and 20-seater options, groups can select a vehicle according to their passenger strength and sightseeing requirements. Whether the plan includes a Pune city tour, temple visit, historical exploration, family outing, one-day sightseeing program, or a complete local tour, a dedicated Tempo Traveller makes it easier to explore Pune's major attractions together.",

topPlaces: [
    {
        title: "Shaniwar Wada",
        description:
            "Shaniwar Wada is one of Pune's most recognized historical landmarks and an important attraction for visitors interested in Maratha history and architecture. Groups choosing Pune Darshan can conveniently include this heritage site in their itinerary while traveling together in a spacious Tempo Traveller."
    },
    {
        title: "Aga Khan Palace",
        description:
            "Aga Khan Palace is a significant historical landmark surrounded by landscaped gardens and associated with an important period of India's freedom movement. Families, tourists, and educational groups can include this destination in a Pune sightseeing itinerary and comfortably continue to other attractions using the same Traveller."
    },
    {
        title: "Sinhagad Fort",
        description:
            "Sinhagad Fort is a popular destination near Pune offering historical significance, hill scenery, and panoramic surroundings. A dedicated Tempo Traveller makes the journey convenient for families and groups who want to combine fort exploration with other Pune attractions during a planned sightseeing day."
    },
    {
        title: "Dagdusheth Halwai Ganpati Temple",
        description:
            "Dagdusheth Halwai Ganpati Temple is one of Pune's most famous religious landmarks and attracts devotees and visitors throughout the year. Families and pilgrimage groups can include the temple in their Pune Darshan itinerary while using one common vehicle for convenient travel between different city attractions."
    },
    {
        title: "Pataleshwar Cave Temple",
        description:
            "Pataleshwar Cave Temple is a historic rock-cut temple located in the heart of Pune and offers visitors a glimpse into the city's architectural and religious heritage. It is an excellent stop for a local sightseeing itinerary and can easily be combined with other nearby attractions."
    },
    {
        title: "Raja Dinkar Kelkar Museum",
        description:
            "Raja Dinkar Kelkar Museum houses an extensive collection of traditional Indian art, artifacts, decorative objects, and cultural items. Travelers interested in history and culture can include the museum in their Pune city tour while enjoying convenient transportation between sightseeing locations."
    },
    {
        title: "Parvati Hill",
        description:
            "Parvati Hill is a well-known Pune landmark offering temple attractions and elevated views across parts of the city. Families and tourists can add this location to a Pune Darshan schedule and use a dedicated Tempo Traveller to move comfortably between Parvati Hill and other sightseeing destinations."
    },
    {
        title: "Lal Mahal",
        description:
            "Lal Mahal is an important historical site in central Pune associated with the early life and history of Chhatrapati Shivaji Maharaj. Visitors exploring Pune's heritage can include the landmark in their city tour along with Shaniwar Wada and other nearby attractions."
    },
    {
        title: "Sinhagad Road",
        description:
            "Sinhagad Road provides access toward several scenic and recreational areas around Pune and can be included in broader local sightseeing plans. Groups can use a spacious Traveller to combine nearby attractions with their Pune Darshan itinerary while maintaining convenient transportation throughout the day."
    },
    {
        title: "Osho Garden",
        description:
            "Osho Garden provides a peaceful green setting within Pune and is a pleasant stop for travelers looking to add a relaxing location to their city tour. Families, friends, and tourists can include the garden along with other Pune attractions as part of a flexible local sightseeing schedule."
    }
],

services: [
    {
        name: "Pune Darshan Tempo Traveller Hire",
        description:
            "Pune Darshan Tempo Traveller Hire is suitable for families, friends, tourists, school groups, corporate teams, and organized parties planning to explore Pune together. Ruturaj Enterprises provides suitable vehicle capacities so groups can visit multiple attractions without the inconvenience of arranging several separate cars."
    },
    {
        name: "Pune Darshan Tempo Traveller Booking",
        description:
            "Pune Darshan Tempo Traveller Booking allows travelers to organize their sightseeing transportation according to group size, itinerary, and preferred travel schedule. It is useful for one-day city tours, family outings, temple visits, historical sightseeing, and organized local travel programs."
    },
    {
        name: "AC Tempo Traveller for Pune Darshan",
        description:
            "AC Tempo Traveller for Pune Darshan provides a comfortable air-conditioned environment for groups spending several hours traveling between different city attractions. Families with children, senior citizens, tourists, and larger groups can enjoy convenient local transportation while keeping everyone together."
    },
    {
        name: "Luxury Tempo Traveller for Pune Darshan",
        description:
            "Luxury Tempo Traveller for Pune Darshan is an appropriate choice for travelers who prefer a more premium group sightseeing experience. It can be considered for corporate outings, family occasions, special visitors, organized tours, and leisure programs where comfortable transportation adds convenience to the overall Pune tour."
    },
    {
        name: "13 Seater Tempo Traveller Pune Darshan",
        description:
            "13 Seater Tempo Traveller Pune Darshan is suitable for medium-sized families, friend groups, small corporate teams, and compact tourist parties. The vehicle provides a practical way to visit several Pune attractions together while accommodating passengers and their personal belongings comfortably."
    },
    {
        name: "17 Seater Tempo Traveller Pune Darshan",
        description:
            "17 Seater Tempo Traveller Pune Darshan works well for larger families, extended friend groups, school or college groups, and organized sightseeing parties. A dedicated 17-seater allows everyone to remain together while moving between historical, religious, cultural, and recreational attractions across Pune."
    },
    {
        name: "20 Seater Tempo Traveller Pune Darshan",
        description:
            "20 Seater Tempo Traveller Pune Darshan is designed for bigger groups that require greater passenger capacity for a complete city sightseeing program. It is useful for organized tours, extended families, corporate outings, educational groups, and event-related local transportation."
    },
    {
        name: "Pune Local Sightseeing Tempo Traveller",
        description:
            "Pune Local Sightseeing Tempo Traveller offers a convenient group transportation solution for exploring major attractions across the city and surrounding areas. Travelers can plan a customized itinerary covering temples, forts, museums, historical landmarks, gardens, and other places according to their available time."
    },
    {
        name: "Pune City Tour Tempo Traveller",
        description:
            "Pune City Tour Tempo Traveller is suitable for visitors and residents planning a comprehensive city exploration program. A dedicated vehicle allows groups to move between multiple attractions according to their schedule while avoiding the coordination challenges associated with several separate vehicles."
    },
    {
        name: "Tempo Traveller for Pune Sightseeing",
        description:
            "Tempo Traveller for Pune Sightseeing provides practical transportation for families, friends, tourists, and organized groups exploring Pune's historical and cultural attractions. The vehicle can support a full-day itinerary with multiple sightseeing stops while keeping the group together throughout the tour."
    },
    {
        name: "Pune Darshan Group Travel Tempo Traveller",
        description:
            "Pune Darshan Group Travel Tempo Traveller is ideal for friends, relatives, office teams, educational groups, and organized tourist parties. A common vehicle simplifies group movement and makes it easier to coordinate sightseeing timings, meal breaks, entry points, and travel between different attractions."
    },
    {
        name: "Pune Darshan Family Trip Tempo Traveller",
        description:
            "Pune Darshan Family Trip Tempo Traveller provides a convenient sightseeing arrangement for families traveling with children, parents, relatives, and senior members. Everyone can remain together while visiting temples, forts, museums, gardens, and other family-friendly attractions across Pune."
    },
    {
        name: "Affordable Tempo Traveller for Pune Darshan",
        description:
            "Affordable Tempo Traveller for Pune Darshan is suitable for groups looking for a practical way to manage local sightseeing transportation. Selecting one vehicle with appropriate seating capacity can reduce the need for multiple cars and make group coordination easier throughout the Pune sightseeing program."
    },
    {
        name: "Tempo Traveller Rental for Pune Sightseeing",
        description:
            "Tempo Traveller Rental for Pune Sightseeing caters to different local tour requirements, including family outings, tourist visits, temple tours, historical exploration, corporate programs, and one-day sightseeing. Groups can select a suitable vehicle according to passenger strength and planned attractions."
    },
    {
        name: "Pune Temple Tour Tempo Traveller",
        description:
            "Pune Temple Tour Tempo Traveller is useful for families and pilgrimage groups planning to visit multiple religious attractions around the city. A dedicated vehicle allows devotees to travel together and organize visits to temples according to their preferred route and available sightseeing time."
    },
    {
        name: "Pune One Day Sightseeing Traveller",
        description:
            "Pune One Day Sightseeing Traveller is designed for groups wanting to cover several attractions within a single day. With one dedicated vehicle, passengers can coordinate their itinerary more efficiently and travel between historical landmarks, temples, museums, gardens, and other popular Pune destinations."
    },
    {
        name: "Pune Tourist Places Tempo Traveller",
        description:
            "Pune Tourist Places Tempo Traveller provides convenient transportation for visitors exploring the city's major tourist attractions. Families, friends, and organized groups can create a sightseeing schedule covering historical sites, religious landmarks, museums, forts, and cultural destinations while traveling together."
    },
    {
        name: "Pune Local Tour Traveller Rental",
        description:
            "Pune Local Tour Traveller Rental is suitable for groups requiring a dedicated vehicle for local exploration and city-based travel. It can support family outings, tourist programs, temple visits, corporate activities, educational tours, and special sightseeing plans across Pune."
    },
    {
        name: "Pune Family Sightseeing Traveller",
        description:
            "Pune Family Sightseeing Traveller offers a practical group transportation option for families planning a day of local exploration. Spacious seating helps keep parents, children, relatives, and senior members together while visiting Pune's historical, religious, cultural, and recreational attractions."
    },
    {
        name: "Pune Group Sightseeing Traveller",
        description:
            "Pune Group Sightseeing Traveller is well suited to friends, corporate teams, college groups, relatives, and organized tourist parties. Traveling in one dedicated vehicle makes it easier to coordinate the complete sightseeing itinerary and move between multiple destinations without splitting the group."
    },
    {
        name: "Pune Historical Tour Tempo Traveller",
        description:
            "Pune Historical Tour Tempo Traveller supports organized visits to the city's forts, palaces, museums, temples, and heritage landmarks. History enthusiasts and educational groups can plan a detailed itinerary while enjoying convenient transportation between important historical locations."
    },
    {
        name: "Pune City Sightseeing AC Traveller",
        description:
            "Pune City Sightseeing AC Traveller provides air-conditioned group transportation for travelers spending an extended day exploring the city. It is suitable for tourists, families, corporate groups, and friends who want a comfortable way to move between multiple Pune attractions."
    }
],

tableData: [
    ["Pune Darshan Tempo Traveller Hire", "Pune Darshan Tempo Traveller Booking"],
    ["AC Tempo Traveller for Pune Darshan", "Luxury Tempo Traveller for Pune Darshan"],
    ["13 Seater Tempo Traveller Pune Darshan", "17 Seater Tempo Traveller Pune Darshan"],
    ["20 Seater Tempo Traveller Pune Darshan", "Pune Local Sightseeing Tempo Traveller"],
    ["Pune City Tour Tempo Traveller", "Tempo Traveller for Pune Sightseeing"],
    ["Pune Darshan Group Travel Tempo Traveller", "Pune Darshan Family Trip Tempo Traveller"],
    ["Affordable Tempo Traveller for Pune Darshan", "Tempo Traveller Rental for Pune Sightseeing"],
    ["Pune Temple Tour Tempo Traveller", "Pune One Day Sightseeing Traveller"],
    ["Pune Tourist Places Tempo Traveller", "Pune Local Tour Traveller Rental"],
    ["Pune Family Sightseeing Traveller", "Pune Group Sightseeing Traveller"],
    ["Pune Historical Tour Tempo Traveller", "Pune City Sightseeing AC Traveller"]
],

whychoose: [
    {
        WhyChooseheading: "Convenient Pune City Exploration",
        WhyChoosedescription:
            "Exploring several Pune attractions in one day becomes easier when the entire group travels in a dedicated vehicle. Ruturaj Enterprises provides suitable Tempo Traveller options that allow families, tourists, friends, and organized groups to follow a common sightseeing itinerary."
    },
    {
        WhyChooseheading: "Multiple Seating Capacities",
        WhyChoosedescription:
            "Different sightseeing groups require different amounts of seating space. The availability of 13-seater, 17-seater, and 20-seater options gives travelers the flexibility to choose transportation according to their group size and planned Pune Darshan program."
    },
    {
        WhyChooseheading: "Ideal for Family Sightseeing",
        WhyChoosedescription:
            "Families can enjoy a more organized Pune tour when children, parents, relatives, and senior members remain together. A dedicated Traveller makes it easier to carry personal belongings and coordinate sightseeing stops, meal breaks, temple visits, and return travel."
    },
    {
        WhyChooseheading: "Useful for Historical Tours",
        WhyChoosedescription:
            "Pune has a rich collection of forts, heritage buildings, museums, and historical landmarks. A group Traveller allows history enthusiasts and educational groups to visit multiple sites during one itinerary without dealing with the inconvenience of arranging separate transportation."
    },
    {
        WhyChooseheading: "Comfortable AC Sightseeing",
        WhyChoosedescription:
            "A full day of city sightseeing can involve frequent travel between attractions, making a comfortable interior especially valuable. Air-conditioned Traveller options provide a pleasant environment for tourists, families, corporate groups, and friends during their Pune Darshan."
    },
    {
        WhyChooseheading: "Perfect for Temple Tours",
        WhyChoosedescription:
            "Religious groups can plan visits to multiple temples and spiritual attractions around Pune using one common vehicle. This arrangement helps families and devotees coordinate their route efficiently while keeping the entire group together throughout the temple tour."
    },
    {
        WhyChooseheading: "Suitable for One-Day Tours",
        WhyChoosedescription:
            "Travelers with limited time can plan a one-day sightseeing schedule covering selected attractions without arranging transportation at every stop. A dedicated Tempo Traveller provides flexibility to organize the day's route around the group's preferred places and available time."
    },
    {
        WhyChooseheading: "Practical for Large Groups",
        WhyChoosedescription:
            "Large groups often face coordination issues when traveling in multiple cars. Choosing a suitable Tempo Traveller keeps passengers together and simplifies communication, sightseeing schedules, luggage handling, and movement between Pune's major tourist destinations."
    }
]


};





const faqData = [
{
question: "Why choose Ruturaj Enterprises for Pune Darshan by Tempo Traveller?",
answer: "Ruturaj Enterprises offers a convenient group travel option for exploring Pune's important attractions in one vehicle. A Tempo Traveller is useful for families, friends, senior citizens, school groups, and visitors who want to cover multiple sightseeing locations together."
},
{
question: "Can families hire a Tempo Traveller for Pune Darshan?",
answer: "Family groups can rent a Tempo Traveller for a comfortable Pune sightseeing tour. Everyone can travel together between different attractions while having convenient seating and space for personal belongings throughout the day."
},
{
question: "Which places can be included in a Pune Darshan tour?",
answer: "A customized Pune Darshan itinerary can include attractions such as Shaniwar Wada, Aga Khan Palace, Sinhagad Fort, Dagdusheth Halwai Ganpati Temple, Pataleshwar Cave Temple, and other locations based on the group's available time and preferences."
},
{
question: "Is a Tempo Traveller suitable for Pune sightseeing with elderly people?",
answer: "Groups traveling with senior citizens can benefit from having dedicated transportation throughout the sightseeing schedule. A Tempo Traveller keeps the family or group together and avoids the inconvenience of arranging several separate vehicles between attractions."
},
{
question: "Can I book an AC Tempo Traveller for Pune Darshan?",
answer: "Travelers who prefer additional comfort can request an AC Tempo Traveller for their Pune sightseeing plan. Ruturaj Enterprises can help arrange a vehicle according to the number of passengers and the group's specific travel requirements."
},
{
question: "Can a large group hire a Tempo Traveller for Pune sightseeing?",
answer: "Larger groups can inquire about suitable seating-capacity options for their Pune Darshan tour. Choosing the right vehicle allows the group to travel together instead of splitting into multiple cars, making the sightseeing schedule easier to coordinate."
},
{
question: "Can I book a Tempo Traveller for a full-day Pune Darshan?",
answer: "A full-day rental can be planned for groups that want to visit several Pune attractions at a comfortable pace. The itinerary can be organized around the preferred pickup point, sightseeing locations, breaks, and expected completion time."
},
{
question: "Is a Tempo Traveller useful for Pune temple sightseeing?",
answer: "Religious sightseeing can be organized with a Tempo Traveller when the group wants to visit multiple temples and spiritual attractions around Pune. Traveling together makes it simpler to manage the group's schedule and movement between different locations."
},
{
question: "Can corporate or college groups use a Tempo Traveller for Pune Darshan?",
answer: "Corporate teams, college groups, and other organized parties can use Tempo Travellers for educational visits, team outings, cultural tours, and city sightseeing. Ruturaj Enterprises can arrange group transportation according to the planned itinerary."
},
{
question: "How can I book a Pune Darshan Tempo Traveller with Ruturaj Enterprises?",
answer: "To reserve a Tempo Traveller, provide Ruturaj Enterprises with your preferred pickup location, sightseeing date, number of passengers, tour duration, and vehicle requirements. The group travel arrangement can then be planned around your Pune Darshan itinerary."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Harshad Joshi",
feedback:
"We hired a Tempo Traveller from Ruturaj Enterprises for Pune Darshan with our relatives. Having everyone in one vehicle made visiting different attractions much easier, and the spacious seating was especially helpful for our elderly family members. The day was comfortable and well coordinated.",
rating: 5
},
{
id: 2,
name: "Miss. Snehal Wagh",
feedback:
"Our group wanted to explore several Pune attractions in a single day, so we booked a Tempo Traveller with Ruturaj Enterprises. The vehicle was convenient for our group, and we could move between the sightseeing spots without worrying about arranging separate cars.",
rating: 5
}
];













    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Darshan Tempo Traveller On Rent",
  "image": "https://ruturajenterprises.com/assets/images/pune-darshan-tempo-traveller-on-rent.webp",
  "description":
    "Pune Darshan Tempo Traveller On Rent from Ruturaj Enterprises is a convenient group transportation option for families, friends, tourists, senior citizens, corporate teams, students and local sightseeing groups who want to explore Pune comfortably in one vehicle. Pune Darshan Tempo Traveller Hire is suitable for full-day sightseeing, half-day city tours, family outings, school and college trips, corporate outings, cultural tours and customized local travel plans. Pune Darshan Tempo Traveller Booking can be arranged according to the number of passengers, preferred pickup location, sightseeing schedule and duration of the tour. AC Tempo Traveller for Pune Darshan provides a comfortable option for local sightseeing throughout the day, while Luxury Tempo Traveller for Pune Darshan is suitable for premium family tours, corporate groups, wedding guests and special occasions. 13 Seater Tempo Traveller Pune Darshan, 17 Seater Tempo Traveller Pune Darshan and 20 Seater Tempo Traveller Pune Darshan offer practical seating choices for different group sizes traveling together. Pune Local Sightseeing Tempo Traveller can cover major attractions including Shaniwar Wada, Aga Khan Palace, Sinhagad Fort, Lal Mahal, Pataleshwar Cave Temple, Dagdusheth Halwai Ganpati Temple, Saras Baug, Parvati Hill, Raja Dinkar Kelkar Museum, Pune-Okayama Friendship Garden, Empress Garden, Khadakwasla Dam, ISKCON NVCC Temple and other popular city attractions. The service is useful for family sightseeing, religious visits, heritage tours, educational trips, corporate outings, group excursions and visiting guests. Pickup can be arranged from major Pune areas such as Kothrud, Baner, Aundh, Wakad, Hinjewadi, Pimpri, Chinchwad, Viman Nagar, Kharadi, Hadapsar, Kondhwa, Katraj, Shivajinagar, Swargate, Talegaon, Moshi, Bhosari and nearby locations. Groups can choose a customized sightseeing route depending on available time, preferred attractions and travel requirements. Pune Darshan Tempo Traveller Full Day is suitable for visiting multiple attractions at a relaxed pace, while half-day and hourly rental options can be arranged for shorter sightseeing schedules. The vehicle can also be used for Pune temple tours, heritage tours, family outings, school trips, college excursions, corporate team outings and guest transportation. Ruturaj Enterprises provides flexible Tempo Traveller rental arrangements with experienced drivers for Pune Darshan, local sightseeing, city tours, family outings, group travel, corporate events and customized sightseeing itineraries.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/pune-darshan-tempo-traveller-on-rent"
  }
};









    return (
        <div>
<Helmet>
  <title>Pune Darshan Tempo Traveller On Rent | Pune Darshan Tempo Traveller Hire | +91 9763381382</title>

  <meta
    name="description"
    content="Pune Darshan Tempo Traveller On Rent for Pune local sightseeing, family tours, temple visits, heritage tours, corporate outings and group travel. Hire AC, Luxury, 13, 17 and 20 Seater Tempo Travellers."
  />

  <meta
    name="keywords"
    content="Pune Darshan Tempo Traveller Hire, Pune Darshan Tempo Traveller Booking, AC Tempo Traveller for Pune Darshan, Luxury Tempo Traveller for Pune Darshan, 13 Seater Tempo Traveller Pune Darshan, 17 Seater Tempo Traveller Pune Darshan, 20 Seater Tempo Traveller Pune Darshan, Pune Local Sightseeing Tempo Traveller, Pune Darshan Tempo Traveller On Rent, Pune Darshan Tempo Traveller Rental, Pune Darshan Tempo Traveller Service, Pune Darshan Tempo Traveller with Driver, Pune Darshan Traveller Hire, Pune Darshan Traveller Booking, Pune Darshan Traveller Rental, Pune Darshan AC Traveller, Pune Darshan Luxury Traveller, Pune Darshan 13 Seater Traveller, Pune Darshan 17 Seater Traveller, Pune Darshan 20 Seater Traveller, Pune Local Sightseeing Tempo Traveller Rental, Pune Local Sightseeing Tempo Traveller Hire, Pune Local Sightseeing Traveller, Pune City Tour Tempo Traveller, Pune City Sightseeing Tempo Traveller, Pune Sightseeing Tempo Traveller, Pune Darshan Tour Package, Pune Darshan Sightseeing Package, Pune Local Tour Tempo Traveller, Pune City Tour Traveller, Pune Local Travel Tempo Traveller, Pune One Day Sightseeing Tempo Traveller, Pune Full Day Sightseeing Tempo Traveller, Pune Half Day Sightseeing Tempo Traveller, Pune Darshan Full Day Tempo Traveller, Pune Darshan Half Day Tempo Traveller, Pune Darshan Hourly Tempo Traveller, Pune Darshan One Day Tour, Pune Local Sightseeing One Day Tour, Pune Local Sightseeing Half Day Tour, Pune Local Sightseeing Full Day Tour, Pune Darshan for Family, Pune Darshan for Group, Pune Darshan for Tourists, Pune Darshan for Senior Citizens, Pune Darshan for Friends, Pune Darshan for Corporate Group, Pune Darshan for School Trip, Pune Darshan for College Trip, Pune Darshan for Family Outing, Pune Darshan for Group Outing, Pune Darshan for Corporate Outing, Pune Darshan for Guest Transportation, Pune Darshan for Tourist Group, Pune Temple Tour Tempo Traveller Pune, Pune Religious Tour Tempo Traveller, Pune Heritage Tour Tempo Traveller, Pune Cultural Tour Tempo Traveller, Pune Educational Tour Tempo Traveller, Pune Historical Tour Tempo Traveller, Pune Weekend Sightseeing Tempo Traveller, Pune Family Sightseeing Tempo Traveller, Pune Group Sightseeing Tempo Traveller, Pune Tourist Sightseeing Tempo Traveller, Pune Corporate Sightseeing Tempo Traveller, Pune Darshan Group Transportation, Pune Darshan Family Transportation, Pune Darshan Tourist Transportation, Pune Darshan Corporate Transportation, Pune Darshan Private Tempo Traveller, Pune Darshan Private Traveller, Pune Darshan Tempo Traveller Rental with Driver, Pune Darshan Tempo Traveller Hire with Driver, Pune Darshan Tempo Traveller Booking with Driver, Affordable Tempo Traveller Pune Darshan, Budget Tempo Traveller Pune Darshan, Comfortable Tempo Traveller Pune Darshan, Premium Tempo Traveller Pune Darshan, Luxury Tempo Traveller Hire Pune Darshan, Luxury Tempo Traveller Rental Pune Darshan, AC Tempo Traveller Hire Pune Darshan, AC Tempo Traveller Rental Pune Darshan, Non AC Tempo Traveller Pune Darshan, Non AC Tempo Traveller Hire Pune Darshan, Non AC Tempo Traveller Rental Pune Darshan, Pune Darshan Full Day Rental, Pune Darshan Half Day Rental, Pune Darshan Hourly Rental, Pune Darshan Weekend Rental, Pune Local Tempo Traveller Full Day, Pune Local Tempo Traveller Half Day, Pune Local Tempo Traveller Hourly, Pune Local Tempo Traveller Rental, Pune Local Tempo Traveller Hire, Pune Local Tempo Traveller Booking, Pune Sightseeing Tempo Traveller Full Day, Pune Sightseeing Tempo Traveller Half Day, Pune Sightseeing Tempo Traveller Hourly, Pune City Sightseeing Rental, Pune City Sightseeing Hire, Pune City Sightseeing Booking, Pune Darshan Temple Tour, Pune Darshan Heritage Tour, Pune Darshan Historical Tour, Pune Darshan Cultural Tour, Pune Darshan Family Tour, Pune Darshan Group Tour, Pune Darshan Tourist Tour, Pune Darshan Corporate Tour, Pune Darshan School Tour, Pune Darshan College Tour, Pune Darshan Road Trip, Pune Darshan Customized Tour, Pune Darshan Customized Sightseeing, Pune Darshan Tour with Driver, Pune Darshan Taxi Alternative, Pune Local Group Transportation, Pune Local Tourist Transportation, Pune Local Family Transportation, Pune Local Corporate Transportation, Pune Local Event Transportation, Pune Local Wedding Guest Transportation, Pune Local Guest Pickup, Pune Local Guest Drop, Pune Local Hotel Transfer, Pune Local Railway Station Transfer, Pune Local Airport Transfer, Pune Airport to Pune Darshan Tempo Traveller, Pune Railway Station to Pune Darshan Tempo Traveller, Pune Hotel to Pune Darshan Tempo Traveller, Pune Darshan from Kothrud, Pune Darshan from Baner, Pune Darshan from Aundh, Pune Darshan from Wakad, Pune Darshan from Hinjewadi, Pune Darshan from Pimpri, Pune Darshan from Chinchwad, Pune Darshan from Viman Nagar, Pune Darshan from Kharadi, Pune Darshan from Hadapsar, Pune Darshan from Kondhwa, Pune Darshan from Katraj, Pune Darshan from Shivajinagar, Pune Darshan from Swargate, Pune Darshan from Talegaon, Pune Darshan from Moshi, Pune Darshan from Bhosari, Tempo Traveller for Shaniwar Wada Pune, Tempo Traveller for Aga Khan Palace Pune, Tempo Traveller for Sinhagad Fort Pune, Tempo Traveller for Lal Mahal Pune, Tempo Traveller for Pataleshwar Cave Temple Pune, Tempo Traveller for Dagdusheth Halwai Ganpati Temple Pune, Tempo Traveller for Saras Baug Pune, Tempo Traveller for Parvati Hill Pune, Tempo Traveller for Raja Dinkar Kelkar Museum Pune, Tempo Traveller for Pune-Okayama Friendship Garden, Tempo Traveller for Empress Garden Pune, Tempo Traveller for Khadakwasla Dam Pune, Tempo Traveller for ISKCON NVCC Pune, Pune Darshan Shaniwar Wada Tempo Traveller, Pune Darshan Aga Khan Palace Tempo Traveller, Pune Darshan Sinhagad Fort Tempo Traveller, Pune Darshan Lal Mahal Tempo Traveller, Pune Darshan Pataleshwar Temple Tempo Traveller, Pune Darshan Dagdusheth Ganpati Tempo Traveller, Pune Darshan Saras Baug Tempo Traveller, Pune Darshan Parvati Hill Tempo Traveller, Pune Darshan Khadakwasla Dam Tempo Traveller, Pune Darshan Pune Heritage Tour Tempo Traveller, Pune Darshan Temple Tour Package, Pune Darshan Family Tour Package, Pune Darshan Group Tour Package, Pune Darshan Corporate Tour Package, Pune Darshan School Trip Package, Pune Darshan College Trip Package, Pune Darshan Tourist Package, Pune Darshan One Day Package, Pune Darshan Sightseeing Package, Pune Darshan Customized Package, Pune Darshan 13 Seater Tempo Traveller Rental, Pune Darshan 17 Seater Tempo Traveller Rental, Pune Darshan 20 Seater Tempo Traveller Rental, Pune Darshan 13 Seater Tempo Traveller Hire, Pune Darshan 17 Seater Tempo Traveller Hire, Pune Darshan 20 Seater Tempo Traveller Hire, Pune Darshan 13 Seater Tempo Traveller Booking, Pune Darshan 17 Seater Tempo Traveller Booking, Pune Darshan 20 Seater Tempo Traveller Booking, Pune Darshan AC 13 Seater Tempo Traveller, Pune Darshan AC 17 Seater Tempo Traveller, Pune Darshan AC 20 Seater Tempo Traveller, Pune Darshan Luxury 13 Seater Tempo Traveller, Pune Darshan Luxury 17 Seater Tempo Traveller, Pune Darshan Luxury 20 Seater Tempo Traveller"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/8.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punedarshantempo ;